import { createReducer } from 'helpers/redux';
import { getLanguageCode } from 'helpers/utilities';
import { DEFAULT_DISTANCE } from 'src/lib/constants';
import qs from 'qs';
import {
  SET_INITIALISED,
  SET_DATA,
  SET_BASEPATH,
  SET_LOADING,
  SET_ERROR,
  SET_COUNTRY,
  SET_DISTANCE,
  SET_QUERY,
  SET_LISTVIEW,
  SET_PLACE,
  SET_COUNTRIES,
  SET_DEALERS_DATA,
  SET_LAT_LNG,
  SET_ALL_DEALERS,
  SET_LOCATION_ERROR,
  SET_BIKE_TYPES,
  SET_SELECTED_BIKE_TYPES,
} from './types';

const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });

export const initialState = {
  initialised: false,
  data: {
    labels: {},
  },
  basepath: '/',
  history: [],
  loading: true,
  filters: {
    country: queryParams.country || getLanguageCode(),
    query: queryParams.query || '',
  },
  dealers: {
    results: [],
    distance: DEFAULT_DISTANCE,
    isNextDistance: false,
    nextDistance: DEFAULT_DISTANCE,
    distances: [],
    distanceUnit: '',
    count: 0,
    skip: 0,
    locationText: '',
    languageCode: queryParams.country || getLanguageCode(),
  },
  distance: parseInt(queryParams.distance, 10),
  listView: true,
  place: null,
  countries: [],
  bikeTypes: [],
  latitude: 0,
  longitude: 0,
  allDealers: {
    loadMore: true,
    dealerCardData: {
      totalCount: 0,
      dealerCards: [],
    },
    labels: {},
    skip: 0,
    take: 0,
    currentUrl: '',
    languageCode: '',
    siteLanguageCode: '',
  },
  locationError: false,
};

const appReducer = createReducer({
  initialState,
  reducers: {
    [SET_INITIALISED]: state => ({
      ...state,
      initialised: true,
      loading: false,
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      loading: action.payload,
    }),
    [SET_DATA]: (state, { payload: { Labels: labels, ...otherLabels } }) => ({
      ...state,
      data: {
        labels: { ...labels, ...otherLabels },
      },
    }),
    [SET_BASEPATH]: (state, action) => ({
      ...state,
      basepath: action.payload,
    }),
    [SET_ERROR]: (state, action) => ({
      ...state,
      error: action.payload,
    }),
    [SET_COUNTRY]: (state, action) => ({
      ...state,
      filters: {
        ...state.filters,
        country: action.payload,
        query: '',
      },
      allDealers: {
        ...state.allDealers,
        skip: 0,
      },
      place: '',
    }),
    [SET_DISTANCE]: (state, action) => ({
      ...state,
      distance: action.payload,
    }),
    [SET_SELECTED_BIKE_TYPES]: (state, action) => ({
      ...state,
      selectedBikeTypes: action.payload,
    }),
    [SET_QUERY]: (state, action) => ({
      ...state,
      filters: {
        ...state.filters,
        query: action.payload.query,
      },
      place: action.payload.method === 'type' ? null : state.place,
      latitude: 0,
      longitude: 0,
      locationError: false,
    }),
    [SET_DEALERS_DATA]: (
      state,
      {
        payload: {
          dealerData: {
            DealerCardData: dealerData,
            Latitude: latitude,
            Longitude: longitude,
            LocationText: locationText,
            Skip: skip,
            LanguageCode: languageCode,
            Input: input,
          },
          options = {},
        },
      }
    ) => {
      const q = new URLSearchParams(window?.location?.search);
      return {
        ...state,
        dealers: {
          results: options.append ? [...state.dealers.results, ...dealerData.DealerCards] : dealerData.DealerCards,
          distance: parseInt(q.get('distance'), 10) || dealerData.Distance,
          distances: dealerData.Distances,
          distanceUnit: dealerData.DistanceMeasurementUnit,
          distanceUnitCalc: dealerData.DistanceMeasurementUnitCalc.toLowerCase(),
          isRatingsApplicable: dealerData.IsRatingsApplicable,
          isNextDistance: dealerData.DealersLocationsForNextDistance,
          nextDistance: dealerData.NextDistance,
          count: dealerData.TotalCount,
          skip,
          latitude: parseFloat(latitude),
          longitude: parseFloat(longitude),
          locationText: locationText || input,
          languageCode,
        },
        latitude: parseFloat(latitude),
        longitude: parseFloat(longitude),
        distance: parseInt(q.get('distance'), 10) || dealerData.Distance,
        filters: {
          ...state.filters,
          query: locationText || input,
          country: languageCode,
        },
        locationError: false,
        place: null,
      };
    },

    [SET_LISTVIEW]: (state, action) => ({
      ...state,
      listView: action.payload,
    }),
    [SET_PLACE]: (state, action) => ({
      ...state,
      place: action.payload,
      latitude: 0,
      longitude: 0,
    }),
    [SET_COUNTRIES]: (state, actions) => ({
      ...state,
      countries: actions.payload,
    }),
    [SET_BIKE_TYPES]: (state, actions) => ({
      ...state,
      bikeTypes: actions.payload,
    }),
    [SET_LAT_LNG]: (state, action) => ({
      ...state,
      latitude: action.payload.latitude,
      longitude: action.payload.longitude,
      filters: {
        ...state.filters,
        query: '',
      },
    }),
    [SET_ALL_DEALERS]: (state, { payload: { allDealerData, options = {} } }) => ({
      ...state,
      allDealers: {
        loadMore: allDealerData.LoadMore,
        dealerCardData: {
          totalCount: allDealerData.DealerCardData.TotalCount,
          dealerCards: options.append
            ? [...state.allDealers.dealerCardData.dealerCards, ...allDealerData.DealerCardData.DealerCards]
            : allDealerData.DealerCardData.DealerCards,
        },
        skip: allDealerData.Skip,
        take: allDealerData.Take,
        currentUrl: allDealerData.CurrentUrl,
        languageCode: allDealerData.LanguageCode,
        siteLanguageCode: allDealerData.SiteLanguageCode,
      },
      data: {
        ...state.data,
        labels: {
          ...state.data.labels,
          ...allDealerData.Labels,
        },
      },
    }),
    [SET_LOCATION_ERROR]: state => ({
      ...state,
      locationError: true,
    }),
  },
});

export default appReducer;
